import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CmsConfig, ConfigModule, I18nModule, NotAuthGuard, UrlModule} from '@spartacus/core';
import {FormErrorsModule, PageSlotModule, SpinnerModule} from '@spartacus/storefront';
import {CustomRegisterComponent} from './custom-register.component';
import {CustomIconsModule} from '../../../../../custom/icons/custom-icons.module';
import {CustomMoreInfoModule} from '../../../../../custom/cms-components/content/custom-more-info/custom-more-info.module';

@NgModule({
  declarations: [CustomRegisterComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    SpinnerModule,
    FormErrorsModule,
    CustomIconsModule,
    CustomMoreInfoModule,
    PageSlotModule,
    ConfigModule.withConfig({
      cmsComponents: {
        RegisterCustomerComponent: {
          component: CustomRegisterComponent,
          guards: [NotAuthGuard]
        },
      },
    } as CmsConfig)
  ]
})
export class CustomRegisterComponentModule { }
